import { Component, OnInit } from '@angular/core';
import { BaseInlineUpdateComponent, InlineContainerService } from 'yt-ng-framework';
import { KursDokumentStavka } from './kurs-dokument-stavka';

@Component({
  selector: 'yt-kurs-dokument-stavka-inline-update',
  templateUrl: './kurs-dokument-stavka-inline-update.component.html'
})
export class KursDokumentStavkaInlineUpdateComponent
 extends BaseInlineUpdateComponent<KursDokumentStavka> {
  constructor(protected inlineContainerService: InlineContainerService<KursDokumentStavka>){
    super(inlineContainerService);
  }
}
